import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { ZeroTrustDmarcHeroSection } from "@/components/insights/zero-trust-dmarc/ZeroTrustDmarcHeroSection";
import { ZeroTrustDmarcTakeaway } from "@/components/insights/zero-trust-dmarc/ZeroTrustDmarcTakeaway";
import { ZeroTrustDmarcFounderQuote } from "@/components/insights/zero-trust-dmarc/ZeroTrustDmarcFounderQuote";
import { ZeroTrustDmarcKeyFindings } from "@/components/insights/zero-trust-dmarc/ZeroTrustDmarcKeyFindings";
import { ZeroTrustDmarcImplementation } from "@/components/insights/zero-trust-dmarc/ZeroTrustDmarcImplementation";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const ZeroTrustEmailDmarc = () => {
  return (
    <>
      <InsightSEO 
        slug="zero-trust-email-dmarc" 
        additionalKeywords={["DMARC 2026", "strict alignment", "zero trust email", "Google Yahoo requirements", "email authentication", "p=reject"]}
      />
      <InsightEngagementTracker slug="zero-trust-email-dmarc" title="Zero-Trust Email DMARC" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Technical" 
          currentPage="Zero-Trust Email: DMARC" 
        />
        <ZeroTrustDmarcHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <ZeroTrustDmarcTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <ZeroTrustDmarcFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <ZeroTrustDmarcKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ZeroTrustDmarcImplementation />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="zero-trust-email-dmarc" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="zero-trust-email-dmarc" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="zero-trust-email-dmarc" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default ZeroTrustEmailDmarc;